import axios from "axios";  
import { BASE_URL } from "../../assets/constants";
import { createFormHeaders, createHeaders } from "../../utils/Utils";
 
//! User APIs
//TODO: User APIs
//  Registered User List
export const listUserAPI = async (data) => {
  const headers = createHeaders()
  return await axios.get(`${BASE_URL}registered-user`,{ params: data, headers: headers?.headers });
};
//  Guest User List
export const listGuestUserAPI = async (data) => {
  const headers = createHeaders()
  return await axios.get(`${BASE_URL}guest-user`,{ params: data, headers: headers?.headers });
};
//  Partner User List
export const listPartnerUserAPI = async (data) => {
  const headers = createHeaders()
  return await axios.get(`${BASE_URL}becomePartner-user`,{ params: data, headers: headers?.headers });
};
//  Partner User List applied by user
export const listPartnerUserApplicationAPI = async (data) => {
  const headers = createHeaders()
  return await axios.get(`${BASE_URL}become-partner-list`,{ params: data, headers: headers?.headers });
};
//  Partner User Verify
export const approvePartnerUserApplicationAPI = async (data) => {
  const headers = createHeaders()
  return await axios.post(`${BASE_URL}update-partner-status`, data,headers );
};
 